import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { Panel } from './shared';

export const PrizePanel = styled(Panel)`
  ${mediaQuery.uptoMobile} {
    padding: 14px;
    gap: 24px;
    display: flex;
    flex-direction: column;
    border-color: #3b0a0f;
  }
`;

export const Hero = styled.section`
  position: relative;
  overflow: hidden;
  background: #000;
  text-align: center;
  padding-bottom: 8px;

  ${mediaQuery.uptoMobile} {
    overflow: visible;
    padding-bottom: 0;
  }
`;

export const HeroStage = styled.div`
  position: relative;
  height: 520px;
  overflow: hidden;

  ${mediaQuery.uptoMobile} {
    height: 190px;
    background: linear-gradient(180deg, #000 0%, #010b41 100%);
  }
`;

export const HeroBg = styled.img`
  display: block;
  width: 100%;
  height: 520px;
  object-fit: cover;
  object-position: center 30%;

  ${mediaQuery.uptoMobile} {
    position: absolute;
    left: -54px;
    top: 0;
    width: 467px;
    height: 176px;
    object-position: center 30%;
  }
`;

export const Fade = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 260px;
  height: 280px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 70%);
  pointer-events: none;

  ${mediaQuery.uptoMobile} {
    top: 90px;
    height: 100px;
  }
`;

export const HeroCopy = styled.div`
  position: absolute;
  left: 50%;
  top: 300px;
  width: min(649px, calc(100% - 32px));
  transform: translateX(-50%);
  z-index: 1;

  ${mediaQuery.uptoMobile} {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 263px;
    max-width: calc(100% - 32px);
    margin: -18px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
`;

export const Subhead = styled.p`
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 2px 1px rgba(0, 0, 0, 0.43);

  ${mediaQuery.uptoMobile} {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.002;
    margin: 0;
    text-shadow: none;
  }
`;

export const Headline = styled.img`
  width: 100%;
  height: auto;

  ${mediaQuery.uptoMobile} {
    width: 263px;
    height: 71px;
    object-fit: cover;
    object-position: center 24%;
  }
`;

export const TimerWrap = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  margin: 28px auto 8px;

  ${mediaQuery.uptoMobile} {
    gap: 8px;
    margin: 19px auto 0;
  }
`;

export const TimerBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  ${mediaQuery.uptoMobile} {
    gap: 8px;
  }
`;

export const TimerBox = styled.div`
  min-width: 117px;
  padding: 11px 16px;
  border-radius: 12px;
  background: #1a0a0d;
  border: 1px solid #461b20;
  font-size: 64px;
  font-weight: 700;
  line-height: 1.15;

  ${mediaQuery.uptoMobile} {
    min-width: 52px;
    font-size: 38px;
    font-weight: 600;
    line-height: 0.83;
    padding: 5px 8px;
    border-radius: 8px;
    background: #211113;
    border: 1px solid #b70e2f;
    box-shadow: inset 0 0 14px #c71d31;
  }
`;

export const TimerSep = styled.span`
  margin-top: 8px;
  font-size: 64px;
  font-weight: 700;
  line-height: 1.15;

  ${mediaQuery.uptoMobile} {
    font-size: 38px;
    font-weight: 600;
    line-height: 0.83;
    margin-top: 5px;
  }
`;

export const TimerLabel = styled.span`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);

  ${mediaQuery.uptoMobile} {
    font-size: 8px;
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const PrizeHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 36px;

  img {
    width: 31px;
    height: 31px;
  }

  ${mediaQuery.uptoMobile} {
    gap: 13px;
    margin-bottom: 0;

    img {
      width: 20px;
      height: 21px;
    }
  }
`;

export const PrizeTitle = styled.h2`
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  text-align: center;

  ${mediaQuery.uptoMobile} {
    font-size: 16px;
  }
`;

export const PrizeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px 18px;

  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const PrizeCardBox = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 31px;
  min-height: 264px;
  padding: 16px 12px;
  border-radius: 16px;
  background: #211113;
  border: 1px solid #461b20;

  ${mediaQuery.uptoMobile} {
    min-height: 274px;
    gap: 13px;
    padding: 8px 9px;
    border-radius: 16px;
  }
`;

export const MysteryArt = styled.div`
  position: relative;
  height: 154px;
  border-radius: 12px;
  background: #130305;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery.uptoMobile} {
    height: 194px;
    width: 100%;
  }
`;

export const Glow = styled.img`
  width: 90px;
  height: 90px;
`;

export const MysteryMark = styled.span`
  position: absolute;
  font-size: 69px;
  font-weight: 600;
  line-height: 0.83;
  background: linear-gradient(180deg, #fdf7ca 0%, #e21835 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  ${mediaQuery.uptoMobile} {
    font-size: 69px;
    text-shadow: 0 3px 0 #611e23;
  }
`;

export const PrizeCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PrizeName = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;

  ${mediaQuery.uptoMobile} {
    font-size: 18px;
  }
`;

export const PrizeSub = styled.p`
  margin: 0;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);

  ${mediaQuery.uptoMobile} {
    font-size: 14px;
  }
`;

export const MoreRow = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 24px 0 0;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);

  &::before,
  &::after {
    content: '';
    width: 86px;
    height: 1px;
    background: rgba(255, 255, 255, 0.25);
  }

  ${mediaQuery.uptoMobile} {
    font-size: 14px;
    margin-top: 0;
    gap: 16px;

    &::before,
    &::after {
      flex: 1;
      width: auto;
    }
  }
`;
